(() => {
  const root = document.querySelector('[data-pack-reviews]');
  if (!root) return;
  const cache = new Map();
  let version = 0, reviews = [], index = 0;
  const show = () => {
    root.hidden = !reviews.length;
    if (!reviews.length) return;
    const r = reviews[index];
    const content = root.querySelector('[data-pack-review-content]');
    content.replaceChildren();
    const header = document.createElement('div');
    header.className = 'kinich-review-carousel__head';
    const stars = document.createElement('span');
    stars.className = 'kinich-review-carousel__stars';
    stars.textContent = '★'.repeat(Number(r.stars)) + '☆'.repeat(5 - Number(r.stars));
    stars.setAttribute('aria-label', r.stars + ' de 5 estrellas');
    const name = document.createElement('strong'); name.textContent = r.customer?.firstName || 'Cliente Kinich';
    header.append(stars, name);
    const product = document.createElement('p'); product.textContent = r.title; product.style.fontSize = '12px';
    const comment = document.createElement('p'); comment.textContent = r.comment;
    content.append(header, product, comment);
    const link = root.querySelector('[data-pack-review-link]'); link.href = r.url + '#cont-rl-w';
    root.querySelector('[data-pack-review-count]').textContent = (index + 1) + ' / ' + reviews.length;
    root.querySelectorAll('button').forEach(b => b.hidden = reviews.length < 2);
  };
  const load = async item => {
    const handle = item.dataset.biscuitsHandle;
    if (!handle || !/^[a-z0-9-]+$/.test(handle)) return [];
    if (!cache.has(handle)) cache.set(handle, (async () => {
      const url = '/products/' + handle + '?view=kinich-prenda';
      try {
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) return [];
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('[data-rvw2-list]');
        if (!source) return [];
        const list = JSON.parse(source.textContent);
        const title = doc.querySelector('h1')?.textContent.trim() || handle;
        const id = item.dataset.biscuitsProductId || item.closest('[data-biscuits-card-id]')?.dataset.biscuitsCardId;
        return list.filter(r => String(r.product?.productId) === id && typeof r.comment === 'string' && r.comment.trim() && Number.isInteger(Number(r.stars)) && Number(r.stars) >= 1 && Number(r.stars) <= 5).map(r => ({...r,title,url}));
      } catch { return []; }
    })());
    return cache.get(handle);
  };
  const update = async () => {
    const all = Array.from(document.querySelectorAll('biscuits-bundle-product[data-biscuits-handle], biscuits-bundle-variant[data-biscuits-handle]'));
    if (!all.length) return;
    const items = Array.from(new Map(all.map(item => [item.dataset.biscuitsHandle, item])).values());
    const current = ++version;
    const lists = [];
    for (let start = 0; start < items.length; start += 3) {
      await Promise.all(items.slice(start, start + 3).map(async item => {
        const loaded = await load(item);
        if (current !== version) return;
        lists.push(loaded);
        const active = reviews[index];
        reviews = lists.flat().sort((a,b) => Number(b.stars) - Number(a.stars));
        index = active ? Math.max(0, reviews.indexOf(active)) : 0;
        show();
      }));
      if (current !== version) return;
    }
  };
  root.querySelector('[data-pack-review-prev]').addEventListener('click', () => {index = (index - 1 + reviews.length) % reviews.length; show();});
  root.querySelector('[data-pack-review-next]').addEventListener('click', () => {index = (index + 1) % reviews.length; show();});
  document.addEventListener('BiscuitsBundleForm:ready', update);
  update();
})();
